"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_SAFETY_RATING_THRESHOLD = void 0;
var _1 = require(".");
exports.BRAND_SAFETY_RATING_THRESHOLD = 1;
var storyPassesBrandSafetyLevel = function (story) {
    var brandSafetyLevel = story === null || story === void 0 ? void 0 : story.brandSafetyLevel;
    if (typeof brandSafetyLevel !== "undefined") {
        return brandSafetyLevel < exports.BRAND_SAFETY_RATING_THRESHOLD;
    }
    else {
        if ((0, _1.getCookie)("debug-ads")) {
            console.log("missing brand safety level");
        }
        return false;
    }
};
exports.default = storyPassesBrandSafetyLevel;
